export default __webpack_public_path__ + "static/media/resources.cdc53c72.svg";